import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const AuthModal = ({ isOpen, onClose }) => {

  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      if (isLogin) {

        await login(email, password);
        toast.success('Welcome back!');
        onClose();

      } else {

        await register(email, password, name);
        toast.success('Account created successfully!');
        onClose();

      }

    } catch (error) {

      toast.error(error.response?.data?.detail || 'Authentication failed');

    } finally {

      setLoading(false);

    }
  };

  const handleForgotPassword = async () => {

  if (!email) {

    toast.error("Enter your email first");
    return;

  }

  try {

  console.log(
  "FORGOT CLICK URL:",
  `https://topnationapp-1-api.onrender.com/api/auth/forgot-password`
);

const response = await fetch(
  `https://topnationapp-1-api.onrender.com/api/auth/forgot-password`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    }
  );
        const text = await response.text();

    console.log("FORGOT PASSWORD RESPONSE:", text);

    const data = text ? JSON.parse(text) : {};

    toast.success(data.message || "Reset email sent");
  } catch (err) {

  console.log(err);

  toast.error("Error sending reset email");

}

};

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#0A0A0A] border-[#FFD700] text-white">

        <DialogHeader>
          <DialogTitle className="text-[#FFD700] font-['Cinzel'] text-2xl uppercase tracking-wider">
            {isLogin ? 'Login' : 'Create Account'}
          </DialogTitle>

          <DialogDescription className="text-gray-400">
            {isLogin ? 'Welcome back to TopNation' : 'Join the empire'}
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">

          {!isLogin && (
            <div>
              <Label htmlFor="name" className="text-gray-300">Name</Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="bg-[#121212] border-[#333] text-white focus:border-[#FFD700]"
                required
              />
            </div>
          )}

          <div>
            <Label htmlFor="email" className="text-gray-300">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#121212] border-[#333] text-white focus:border-[#FFD700]"
              required
            />
          </div>

          <div>
            <Label htmlFor="password" className="text-gray-300">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#121212] border-[#333] text-white focus:border-[#FFD700]"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full btn-gold"
            disabled={loading}
          >
            {loading ? 'Processing...' : isLogin ? 'Login' : 'Create Account'}
          </Button>

{isLogin && (
  <div className="text-center">
    <button
      type="button"
      onClick={handleForgotPassword}
      className="text-sm text-[#FFD700] hover:underline"
    >
      Forgot password?
    </button>
  </div>
)}
 

          <div className="text-center text-sm">
            <button
              type="button"
              onClick={() => setIsLogin(!isLogin)}
              className="text-[#FFD700] hover:underline"
            >
              {isLogin
                ? "Don't have an account? Sign up"
                : 'Already have an account? Login'}
            </button>
          </div>

        </form>

      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
